import { env } from '$env/dynamic/public'
import type { LoaderOptions } from '@googlemaps/js-api-loader'
import { defaultLocale, locale } from '$lib//translations'

export const loaderOptions: LoaderOptions = {
  apiKey: env.PUBLIC_GOOGLE_MAPS_API_KEY || '',
  language: locale?.get() || defaultLocale,
  libraries: ['places', 'maps'],
  version: 'weekly'
}
